import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import isEqual from "lodash/isEqual";
import WatermarkProvider from "components/product-media/watermark-provider";
import { ContentLoading } from "components/content-loading";
import { makeStyles } from "@material-ui/core/styles";

class Image extends PureComponent {
    static propTypes = {
        style: PropTypes.object,
        className: PropTypes.string,
        alt: PropTypes.string,
        // turns on watermarking for carousel views
        showWatermark: PropTypes.bool,
        src: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            imagesToTry: Array.isArray(props.src) ? props.src.slice(0) : [props.src],
        };

        this.handleError = this.handleError.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.src, nextProps.src)) {
            const arr = Array.isArray(nextProps.src) ? nextProps.src.slice(0) : [nextProps.src];
            this.setState({
                imagesToTry: arr,
                src: null,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(this.props.src, prevProps.src)) {
            this.loadNextImage();
        }
    }

    UNSAFE_componentWillMount() {
        this.loadNextImage();
    }

    loadNextImage() {
        const src = this.state.imagesToTry.shift();
        this.setState({ src, imagesToTry: this.state.imagesToTry });
    }

    handleError() {
        this.loadNextImage();
    }

    render() {
        const { style, className, alt, showWatermark = false } = this.props;
        const { src, imagesToTry } = this.state;

        if (!src) {
            return null;
        }
        return showWatermark ? (
            <WatermarkProvider imageUrl={src}>
                {(src, isLoading) =>
                    isLoading ? (
                        <Loading />
                    ) : (
                        <img
                            role="presentation"
                            src={src}
                            alt={alt}
                            style={style}
                            className={className}
                            onError={imagesToTry.length ? this.handleError : undefined}
                        />
                    )
                }
            </WatermarkProvider>
        ) : (
            <img
                role="presentation"
                src={src}
                alt={alt}
                style={style}
                className={className}
                onError={imagesToTry.length ? this.handleError : undefined}
            />
        );
    }
}

const Loading = () => {
    const classes = useStyles();
    return <ContentLoading className={classes.root} />;
};

const useStyles = makeStyles({
    root: {
        background: "transparent",
    },
});

export default Image;
